import contactus from '../../../api/company/contactus'

// initial state
const state = {
}

// getters
const getters = {
}

// actions
const actions = {
  contactUs ({ commit }, data) {
    return new Promise((resolve, reject) => {
      contactus.contactUs(data)
        .then(res => {
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/company/contactus.js